import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import * as reportService from "../../utilities/services/report"
import Layout from "../../components/Layout"

const ReportExpenses = () => {
  const { token } = useSelector(state => state.user)
  const fromRef = useRef(null)
  const toRef = useRef(null)
  const [expenses, setExpenses] = useState([])
  const [filters, setFilters] = useState({})

  const getExpenses = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await reportService.getExpenses(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setExpenses(response.expenses)
    } catch (error) {
      setExpenses([])
    }
  }

  const handleSearch = () => {
    const where = {}

    if (fromRef.current.value && toRef.current.value) {
      where.from = moment(fromRef.current.value).format("YYYY-MM-DD")
      where.to = moment(toRef.current.value).format("YYYY-MM-DD")
    }

    setFilters(where)
  }

  const handleReset = () => {
    setFilters({})
    fromRef.current.value = ''
    toRef.current.value = ''
  }

  useEffect(() => {
    getExpenses({})
  }, [])

  useEffect(() => {
    getExpenses(filters)
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Expenses</p>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={fromRef} type="date" className="form-control form-control-sm rounded-3" name="from" id="from" />
                </div>
                <div className="col-md-2">
                  <input ref={toRef} type="date" className="form-control form-control-sm rounded-3" name="to" id="to" />
                </div>
                <div className="col-md-6" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <table className="table table-sm table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Order Date</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Total Quantity</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Total Product Cost</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Total Sales Value</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Number Of Orders</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Total Delivery Charges</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Labor</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Delivery Cost Percentage</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Labor Cost Percentage</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle">Total Production Cost Percentage</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map((expense, index) => (
                  <tr key={index}>
                    <td className="align-middle">{expense.order_date}</td>
                    <td className="align-middle">{expense.total_quantity}</td>
                    <td className="align-middle">{expense.total_product_cost}</td>
                    <td className="align-middle">{expense.total_sales_value}</td>
                    <td className="align-middle">{expense.number_of_orders}</td>
                    <td className="align-middle">{expense.total_delivery_charges}</td>
                    <td className="align-middle">{expense.labor}</td>
                    <td className="align-middle">{expense.delivery_cost_percentage?.toFixed(2)}%</td>
                    <td className="align-middle">{expense.labor_cost_percentage?.toFixed(2)}%</td>
                    <td className="align-middle">{expense.total_production_cost_percentage?.toFixed(2)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default ReportExpenses
